import { render } from "./BScroll.vue?vue&type=template&id=3023daf6&scoped=true"
import script from "./BScroll.vue?vue&type=script&lang=js"
export * from "./BScroll.vue?vue&type=script&lang=js"

import "./BScroll.vue?vue&type=style&index=0&id=3023daf6&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3023daf6"]])

export default __exports__